import type { ProviderFormState } from "./types";

const inputClass =
  "w-full h-10 px-3 border border-border bg-background text-sm focus:outline-none focus:border-primary transition-colors";
const selectClass = inputClass;
const labelClass = "text-micro block mb-2";

interface Props {
  form: ProviderFormState;
  update: (field: string, value: any) => void;
}

export default function TabStammdaten({ form, update }: Props) {
  return (
    <div className="space-y-8">
      <section className="border border-border bg-card p-6 space-y-6">
        <h3 className="text-subheadline">Stammdaten</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelClass}>Unternehmen *</label>
            <input value={form.company_name} onChange={(e) => update("company_name", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Rechtlicher Name</label>
            <input value={form.legal_name} onChange={(e) => update("legal_name", e.target.value)} placeholder="z.B. GmbH-Name lt. HR" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Kontaktperson *</label>
            <input value={form.contact_name} onChange={(e) => update("contact_name", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Rolle / Position</label>
            <input value={form.contact_role} onChange={(e) => update("contact_role", e.target.value)} placeholder="z.B. Geschäftsführer, CTO" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>E-Mail *</label>
            <input type="email" value={form.contact_email} onChange={(e) => update("contact_email", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Telefon</label>
            <input value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="+49 ..." className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Website</label>
            <input value={form.website} onChange={(e) => update("website", e.target.value)} placeholder="https://..." className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Invoice E-Mail</label>
            <input type="email" value={form.invoice_email} onChange={(e) => update("invoice_email", e.target.value)} placeholder="buchhaltung@unternehmen.de" className={inputClass} />
            <p className="text-micro mt-1">E-Mail-Adresse für Rechnungsversand</p>
          </div>
        </div>
      </section>

      <section className="border border-border bg-card p-6 space-y-6">
        <h3 className="text-subheadline">Adresse</h3>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            <label className={labelClass}>Straße & Hausnummer</label>
            <input value={form.address_line1} onChange={(e) => update("address_line1", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>PLZ</label>
            <input value={form.postal_code} onChange={(e) => update("postal_code", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Stadt</label>
            <input value={form.city} onChange={(e) => update("city", e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Land</label>
            <select value={form.country} onChange={(e) => update("country", e.target.value)} className={selectClass}>
              <option value="DE">Deutschland</option>
              <option value="AT">Österreich</option>
              <option value="CH">Schweiz</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>USt-IdNr.</label>
            <input value={form.vat_id} onChange={(e) => update("vat_id", e.target.value)} placeholder="DE123456789" className={inputClass} />
          </div>
        </div>
      </section>

      <section className="border border-border bg-card p-6 space-y-6">
        <h3 className="text-subheadline">Unternehmensdaten</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelClass}>Geschäftsführer</label>
            <input value={form.geschaeftsfuehrer} onChange={(e) => update("geschaeftsfuehrer", e.target.value)} placeholder="Max Mustermann" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Gegründet (Jahr)</label>
            <input type="number" value={form.gruendungsjahr} onChange={(e) => update("gruendungsjahr", e.target.value)} placeholder="z.B. 2005" min="1900" max="2099" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Bonität</label>
            <select value={form.bonitaet_rating} onChange={(e) => update("bonitaet_rating", e.target.value)} className={selectClass}>
              <option value="">– Nicht bewertet –</option>
              <option value="excellent">Ausgezeichnet</option>
              <option value="good">Gut</option>
              <option value="moderate">Moderat</option>
              <option value="poor">Mangelhaft</option>
              <option value="unknown">Unbekannt</option>
            </select>
          </div>
        </div>
      </section>

      <section className="border border-border bg-card p-6 space-y-6">
        <h3 className="text-subheadline">Status & Freischaltung</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelClass}>Billing-Status</label>
            <select value={form.billing_status} onChange={(e) => update("billing_status", e.target.value)} className={selectClass}>
              <option value="active">Aktiv</option>
              <option value="paused">Pausiert</option>
              <option value="blocked">Gesperrt</option>
            </select>
          </div>
          <div className="flex items-end">
            <label className="flex items-center gap-3 cursor-pointer pb-2">
              <input type="checkbox" checked={form.is_approved} onChange={(e) => update("is_approved", e.target.checked)} className="w-4 h-4 accent-accent" />
              <span className="text-sm">Sofort freischalten</span>
            </label>
          </div>
        </div>
      </section>
    </div>
  );
}
